import React from 'react';
import { FadeIn } from './FadeIn';
export function FinalCTA() {
  return <section className="py-16 px-3 bg-surface/20 text-center relative overflow-hidden border-t border-ink/10" data-id="element-62">
      <div className="absolute inset-0 opacity-[0.02] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-accent via-transparent to-transparent" data-id="element-63" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-64">
        <FadeIn data-id="element-65">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-accent mb-6" data-id="element-66">
            MegaPack Inclusión Lista™
          </h2>

          <p className="text-base md:text-lg text-ink/80 font-medium mb-8 leading-relaxed max-w-2xl mx-auto" data-id="element-67">
            Podés seguir resolviendo cada sesión desde cero — o tener una
            biblioteca profesional organizada, visual y lista para imprimir,
            pensada para acompañarte con más claridad y mejores herramientas de
            intervención.
          </p>
        </FadeIn>
      </div>
    </section>;
}